const importAll = context => {
  const map = {}
  for (const key of context.keys()) {
    const keyArr = key.split('/')
    var item = keyArr.pop() // 移除.
    item = item.split('.')[0]
    map[item] = context(key).default
  }
  return map
}
export default importAll



// WEBPACK FOOTER //
// ./src/area-core/utils/importAll.js